import React from 'react';
import PropTypes from 'prop-types';
import {
  DtpRadioGroup,
  DtpRadio,
} from 'dtp-react-components';

const Radio = (props) => {
  const renderSelectItem = item => (
    <DtpRadio value={item.value} label={item.label} disabled={props.disabled} />
  );

  const optionsButtonList = props.itemList.map(item => renderSelectItem(item));

  return (
    <DtpRadioGroup
      name={props.name}
      selectedValue={props.value}
      {...props}
    >
      {optionsButtonList}
    </DtpRadioGroup>
  );
};

Radio.defaultProps = {
  value: null,
  name: null,
  disabled: false,
};

Radio.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  disabled: PropTypes.bool,
  name: PropTypes.string,
  itemList: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })).isRequired,
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/Radio.jsx